import React from 'react';
import { formatLabel } from 'utils/helpers';
import { hasContent, renderPrecautions } from './utils';

const FirstAidSection = ({ chemicalDetails }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 transition-all duration-300 hover:shadow-xl">
      <h2 className="text-2xl font-bold mb-6">
        <i className="fas fa-plus-circle mr-2"></i>First Aid
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {chemicalDetails.first_aid && Object.entries(chemicalDetails.first_aid).map(([key, value]) => (
          hasContent(value) && (
            <div key={key} className="rounded-lg p-6 shadow border bg-gray-50">
              <div className="font-bold text-lg mb-2">{formatLabel(key)}</div>
              <div>{renderPrecautions(value)}</div>
            </div>
          )
        ))}
      </div>
    </div>
  );
};

export default FirstAidSection;
